// 正则匹配
export default  {
  Pattern: {
    isEmpty: /(^\s*)|(\s*$)/g,
    isMobile: /^1[3456789]\d{9}$/,
    isCnAndEn: /^[\u2E80-\uFE4F]+$/,
    isCnAndEnAndNum: /^[\u2E80-\uFE4F-a-zA-Z0-9]+$/,
    isUserRealName: /^[\u2E80-\uFE4F]{2,8}$/,
    isUserName: /^[(\u2E80-\uFE4F)a-zA-Z]+$/,
    isPassword: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
    isAuthCode: /^[0-9]{6}$/,
    isTelAndMobile: /^(1[3|4|5|7|8][\d]{9}|0[\d]{2,3}-[\d]{7,8}|400[-]?[\d]{3}[-]?[\d]{4})$/,
    isEmail: /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/
  },
  /**
   * 执行正则表达式
   * @param pattern 校验的正则表达式
   * @param strValue 校验的值
   * @returns {boolean}
   */
  executeExp(pattern, strValue) {
    return pattern.test(strValue);
  },
  /**
   * 判断字符串是否为空
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isEmpty(strValue) {
    strValue = strValue.replace(this.Pattern.isEmpty, '');
    return !strValue.length;
  },
  /**
   * 判断字符串是否非空
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isNotEmpty(strValue) {
    return !this.isEmpty(strValue);
  },
  /**
   * 判断是否为中文
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isCnAndEn(strValue) {
    if (this.isEmpty(strValue)) {
      return false;
    }

    return this.executeExp(this.Pattern.isCnAndEn, strValue);
  },
  /**
   * 判断是否为真实中文名
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isRealName(strValue) {
    if (this.isEmpty(strValue)) {
      return false;
    }

    return this.executeExp(this.Pattern.isUserRealName, strValue);
  },
  /**
   * 判断是否为中英文、数字及'-'
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isCnAndEnAndNum(strValue) {
    if (this.isEmpty(strValue)) {
      return false;
    }

    return this.executeExp(this.Pattern.isCnAndEnAndNum, strValue);
  },
  /**
   * 判断是否为用户名
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isUserName(strValue) {
    if (this.isEmpty(strValue)) {
      return false;
    }

    return this.executeExp(this.Pattern.isUserName, strValue);
  },
  /**
   * 判断验证码格式
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isAuthCode(strValue) {
    if (this.isEmpty(strValue)) {
      return false;
    }
    return this.executeExp(this.Pattern.isAuthCode, strValue);
  },
  /**
   * 判断是否为手机号码
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isMobile(strValue) {
    if (this.isEmpty(strValue)) {
      return false;
    }
    return this.executeExp(this.Pattern.isMobile, strValue);
  },
  /**
   * 判断是否为电子邮箱
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isEmail(strValue) {
    if (this.isEmpty(strValue)) {
      return false;
    }
    return this.executeExp(this.Pattern.isEmail, strValue);
  },
  /**
   * 判断是否为手机或电话号码
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isTelAndMobile(strValue) {
    if (this.isEmpty(strValue)) {
      return false;
    }
    return this.executeExp(this.Pattern.isTelAndMobile, strValue);
  },
  /**
   * 判断是否符合密码规则
   * @param strValue 校验的值
   * @returns {boolean}
   */
  isPassword(strValue) {
    if (this.isEmpty(strValue)) {
      return false;
    }
    return this.executeExp(this.Pattern.isPassword, strValue);
  },
  /**
   * 对象是否为空
   * @param obj 检验对象
   * @returns {boolean}
   */
  isEmptyObj(obj) {
    return Object.keys(obj).length === 0;
  },
  /**
   * 是否在范围长度内
   * @param 范围数组 [1, 10] 长度在1-10内
   * @returns {boolean}
   */
  isLenRange(strValue, lenArr) {
    return strValue.length >= lenArr[0] && strValue.length <= lenArr[1];
  },
  /**
   * 是否在数值范围内
   * @param 范围数组 [1, 10] 数值在1-10内
   * @returns {boolean}
   */
  isNumRange(numValue, numArr) {
    return numValue >= numArr[0] && numValue <= numArr[1];
  },
  /**
   * 验证身份证号
   * @param el 号码输入input
   * @returns {boolean}
   */
  checkCardNo(el) {
    let txtval = el.value;
    let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    return reg.test(txtval);
  },
  /**
   * 验证身份证号 强
   * @param sId 号码
   * @returns {boolean || string}
   */
  isCardId(sId) {
    let aCity = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外'
    };
    let iSum = 0;
    // let info = '';
    if (!/^\d{17}(\d|x)$/i.test(sId)) return '你输入的身份证长度或格式错误';
    sId = sId.replace(/x$/i, 'a');
    if (aCity[parseInt(sId.substr(0, 2), 10)] === null) {
      return '你的身份证地区非法';
    }
    let sBirthday =
      sId.substr(6, 4) +
      '-' +
      Number(sId.substr(10, 2)) +
      '-' +
      Number(sId.substr(12, 2));
    let d = new Date(sBirthday.replace(/-/g, '/'));
    if (
      sBirthday !=
      d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    ) {
      return '身份证上的出生日期非法';
    }
    for (let i = 17; i >= 0; i--) {
      iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
    }
    if (iSum % 11 != 1) return '你输入的身份证号非法';
    //aCity[parseInt(sId.substr(0,2))]+","+sBirthday+","+(sId.substr(16,1)%2?"男":"女");//此次还可以判断出输入的身份证号的人性别
    return true;
  }
};

